import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Search, FileCheck, ArrowRight } from 'lucide-react';
import { createPageUrl } from '../../utils';

export default function DebtorQuickActions() {
  const quickActions = [
    {
      label: 'Data Debitur',
      icon: Users,
      link: 'DebtorList',
      color: 'bg-amber-500',
    },
    {
      label: 'Pencarian Dokumen',
      icon: Search,
      link: 'DocumentSearch',
      color: 'bg-blue-500',
    },
    {
      label: 'Validasi Dokumen',
      icon: FileCheck,
      link: 'DocumentValidation',
      color: 'bg-green-500',
    },
  ];

  return (
    <div className="bg-white rounded-lg border shadow-sm">
      <div className="p-4 border-b">
        <h3 className="text-lg font-semibold">Akses Cepat</h3>
      </div>
      <div className="p-4 space-y-2">
        {quickActions.map(action => (
          <Link key={action.link} to={createPageUrl(action.link)}>
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors">
              <div className="flex items-center gap-3">
                <div
                  className={`w-8 h-8 rounded-lg ${action.color} flex items-center justify-center`}
                >
                  <action.icon className="w-4 h-4 text-white" />
                </div>
                <span className="font-medium">{action.label}</span>
              </div>
              <ArrowRight className="w-4 h-4 text-gray-400" />
            </button>
          </Link>
        ))}
      </div>
    </div>
  );
}
